import React from 'react'

import { H2, H1, Span } from '@vp/swan'

import { useProject } from './contexts/ProjectContext'

type ProductNameProps = {
  renderAs: 'h1' | 'h2'
}

const ProductName: React.FC<ProductNameProps> = ({ renderAs }) => {
  const { productName, projectNumber, projectCount } = useProject()
  if (renderAs === 'h2')
    return (
      <H2 fontSkin="title-subsection">
        {projectCount > 1 && <Span paddingRight={4}>{`${projectNumber}/${projectCount}`}</Span>}
        {productName}
      </H2>
    )
  else return <H1 fontSkin="title-subsection">{productName}</H1>
}

export default ProductName
